import { render } from "./Store.vue?vue&type=template&id=b624c8b0"
import script from "./Store.vue?vue&type=script&lang=js"
export * from "./Store.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/vhosts/localhost/storage/app/public/taherdanakstore-site/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__